export enum ProfessionalTypeEnum {
    INVOICE = 'INVOICE',
    OPERATING_LICENSE = 'OPERATING_LICENSE',
    PROFESSIONAL_COUNCIL = 'PROFESSIONAL_COUNCIL'
}